// utils/storage.ts
//저장
export function setWithExpiry(key: string, value: string, ttlMs: number) {
  const now = Date.now();
  const item = {
    value,
    expiry: now + ttlMs,
  };
  localStorage.setItem(key, JSON.stringify(item));
}
// 삭제
export function getWithExpiry(key: string): string | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const { value, expiry } = JSON.parse(raw);
    if (Date.now() > expiry) {
      localStorage.removeItem(key); // ✅ 만료된 경우 삭제
      return null;
    }
    return value;
  } catch {
    localStorage.removeItem(key); // ✅ 파싱 실패 시 삭제
    return null;
  }
}
